import { ReactNode, Dispatch, SetStateAction } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

type ModalProps = {
    isOpen: boolean;
    closeModal: Dispatch<SetStateAction<boolean>>;
    children: ReactNode;
    className: string;
  };
  
  const Modal = ({ isOpen, closeModal, children, className }: ModalProps) => {
      return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[99999999999]" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-primary/55 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto p-4 overflow-x-hidden ">
                    <div className="flex min-h-full items-center justify-center text-center z-50 w-full">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className={`w-full max-w-full transform overflow-hidden rounded-2xl border border-black/10 bg-white text-left align-middle shadow-[0_30px_90px_rgba(17,24,22,0.26)] transition-all ${className}`}
                            >
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default Modal;
